import { render } from "./ArticleArchivePage.vue?vue&type=template&id=79a57202"
import script from "./ArticleArchivePage.vue?vue&type=script&lang=js"
export * from "./ArticleArchivePage.vue?vue&type=script&lang=js"

import "./ArticleArchivePage.vue?vue&type=style&index=0&id=79a57202&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__